import React from "react";
import clx from "clsx";
function TextArea(props) {
  let cl = clx(
    `w-full px-3 py-2 transition-all duration-300 ease-in-out rounded text-gray-800 border focus:outline-none  focus:border-blue-500 focus:border-2 `,
    {
      "opacity-75 cursor-not-allowed": props.disabled,
      "border-red-400": props.error,
     
    }
  );
  return (
    <textarea
      {...props}
      className={cl}
    ></textarea>
  );
}

export default TextArea;
